<template>
  <v-dialog v-model="isOpen" max-width="700px">
    <v-card height="425px">
      <v-card-title>
        <v-tabs v-model="tab">
          <v-tab>
            {{ $t('Security.Tabs.general') }}
          </v-tab>
          <v-tab>
            {{ $t('Security.Tabs.password') }}
          </v-tab>
        </v-tabs>
      </v-card-title>
      <v-card-text>
        <v-container class="fill-height">
          <v-tabs-items v-model="tab">
            <v-tab-item>
              <v-alert 
                :color="user.hasTwoFactorAuth ? 'primary' : 'warning'" 
                icon="security" 
                border="right" 
                dark 
                prominent
              >
                <v-row align="center">
                  <v-col class="grow">
                    {{ $t('Security.TwoFactor.' + (user.hasTwoFactorAuth ? 'enabled' : 'disabled')) }}
                  </v-col>
                  <v-col class="shrink">
                    <v-btn outlined @click="switch2FA" :loading="submitting">
                      {{ $t('Security.TwoFactor.' + (user.hasTwoFactorAuth ? 'disable' : 'enable')) }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-alert>
            </v-tab-item>
            <v-tab-item>
              <PasswordForm v-model="password" @validation="value => passwordIsValid = value" @enter="() => passwordIsValid && changePassword()"/>
              <v-btn color="primary" 
                :disabled="!passwordIsValid" 
                block 
                @click="changePassword"
              >
                {{$t('Global.Action.confirm')}}
              </v-btn>
            </v-tab-item>
          </v-tabs-items>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { UserRepository } from '@portal/api'
import PasswordForm from '@/components/Utils/PasswordForm'
import { mapState } from 'vuex'

export default {
  name: 'UserSecurityModal',
  components: { PasswordForm },
  props: {
    show: {required: true, type: Boolean}
  },
  data () {
    return {
      tab: null,
      submitting: false,
      passwordIsValid: false,
      password: '',
    }
  },
  computed: {
    ...mapState('auth', [
      'user'
    ]),
    isOpen: {
      get() {
        return this.show
      },
      set() {
        this.close()
      }
    },
  },
  methods: {
    close () {
      this.$emit('close')
    },
    async switch2FA () {
      this.submitting = true
      try {
        const user = await UserRepository.update('me', { hasTwoFactorAuth: !this.user.hasTwoFactorAuth })
        this.$store.commit('auth/setUser', user)
      } catch (error) {
        this.$store.dispatch('notify/error', 'Error enabling 2FA')
      }
      this.submitting = false
    },
    async changePassword () {
      this.submitting = true
      try {
        await UserRepository.update('me', { plainPassword: this.password })
        this.$store.dispatch('notify/success', this.$t('Security.Password.updated'))
        this.password = ''
      } catch (error) {
        this.$store.dispatch('notify/error', this.$t('Security.Password.notUpdated'))
      }
      this.submitting = false
    }
  }
}
</script>
